import {IStateService} from "angular-ui-router";
import {LoDashStatic} from "lodash";

require('./bookingDetails.less');
const _ = <LoDashStatic>require('lodash');

class BookingDetailsController {
    shipmentDetails = [];
    activeShipment;
    parameters;

    constructor(private toastService, private $state: IStateService, private $stateParams, private $filter, private $location, private $mdDialog, private Shipments) {
    }

    $onInit() {
        this.parameters = this.$stateParams;
        this.Shipments.getShipmentLines(this.$stateParams).$promise.then((results) => {
            this.sortDetails(results);
        }, (error) => {
            this.toastService.parseError(error);
        });

        this.Shipments.getShipments({
            fromDate: this.$stateParams.date,
            toDate: this.$stateParams.date,
            customerNo: this.$stateParams.customerNo,
            customerName: this.$stateParams.customerName,
            address: this.$stateParams.address,
            chartererNo: this.$stateParams.chartererNo
        }).$promise.then((results) => {
            this.activeShipment = results.shipmentsByDate[results.dates[0]][0];
            this.activeShipment.volume = this.$filter('numberv2')(this.activeShipment.volume, 2);
            this.activeShipment.calculatedVolume = this.$filter('numberv2')(this.activeShipment.calculatedVolume, 2);
        });
    }

    goBack() {
        window.history.back();
    }

    volumeUpdated() {
        if (this.activeShipment.shipmentId) {
            this.Shipments.updateShipment({shipmentId: this.activeShipment.shipmentId}, this.activeShipment).$promise.then((shipment) => {
                this.activeShipment = shipment;
            }, (error) => {
                this.toastService.parseError(error);
            });
        } else {
            this.Shipments.createShipment({
                date: this.$stateParams.date,
                customerNo: this.activeShipment.customerNo,
                customerName: this.activeShipment.deliveryCustomerName,
                address: this.activeShipment.deliveryAddress1,
                address2: this.activeShipment.deliveryAddress2,
                chartererNo: this.activeShipment.chartererCompanyNo
            }, this.activeShipment).$promise.then((shipment) => {
                this.activeShipment.shipmentId = shipment;
            }, (error) => {
                this.toastService.parseError(error);
            });
        }
    }

    sortDetails(details) {
        const storageTypeNums = _.sortBy(_.uniq(_.map(details, "location")));

        storageTypeNums.forEach((location) => {
            const shipmentLinesByType = _.filter(details, {location: location}).map((line: any) => {
                line['calculatedVolume'] = line.volume * line.volumeFactor;
                return line;
            });
            this.shipmentDetails.push({heading: shipmentLinesByType[0].storageTypeName, lines: shipmentLinesByType});
        });
    }
}

class BookingDetailsOptions implements ng.IComponentOptions {
    controllerAs = 'c';
    public controller: string = "rkcBookingDetailsController";
    public template: any = require('./bookingDetails.html');

}

rkcApp.controller("rkcBookingDetailsController", ['toastService', '$state', '$stateParams', '$filter', '$location', '$mdDialog', 'Shipments', function (toastService, $state, $stateParams, $filter, $location, $mdDialog, Shipments) {
    return new BookingDetailsController(toastService, $state, $stateParams, $filter, $location, $mdDialog, Shipments);
}])
    .component("rkcBookingDetails", new BookingDetailsOptions());




/** WEBPACK FOOTER **
 ** ./src/app/components/main/views/booking/bookingDetails/bookingDetails.ts
 **/